import React from "react";
import Container from "../Common/Container";
import RowContainer from "../Common/RowContainer";
import Particles from "../Common/ParticleDesign";
import { removeInlineColors } from "../../utils/htmlColorUtils";

interface DropdownValue {
  id: number;
  pId: number;
  name: string;
  children: any[];
  particleType: string;
  particleType1: string;
  particleValue: string;
  particleValue1: string;
}

interface ParticlesData {
  inputValue: string;
  dropdownValue: DropdownValue;
}

interface Data {
  id: number;
  flashCardContentComponentId: number;
  particles: ParticlesData;
  description: string;
}

interface GrammarSingleComponentProps {
  data: Data;
  lightTheme?: string;
  isBretzel?: boolean;
  /** True when rendered inside GrammarGroupComponent — suppresses own bg/border */
  isInsideGroup?: boolean;
  /** Resolved text colour from the parent group */
  groupTextColor?: string;
  onClick?: () => void;
}

const GrammarSingleComponent: React.FC<GrammarSingleComponentProps> = ({
  data,
  lightTheme,
  isInsideGroup = false,
  groupTextColor,
  onClick,
}) => {
  const particles = data.particles || { inputValue: "", dropdownValue: {} };

  // When standalone: own bg based on lightTheme
  // When inside a group: each child has its own bg (passed via groupTextColor + derived from lightTheme)
  const textColor = isInsideGroup && groupTextColor
    ? groupTextColor
    : lightTheme === "Light" ? "#16162F" : "#FFFFFF";

  const bgColor = isInsideGroup
    ? (lightTheme === "Light" ? "#FFFFFF" : "#110929")
    : (lightTheme === "Light" ? "#FFFFFF" : "#110929");

  return (
    <Container
      bgColor={bgColor}
      color={textColor}
      width="100%"
      borderRadius="24px"
      padding="16px"
      cursor="pointer"
      onClick={onClick}
    >
      <RowContainer
        alignItem="center"
        flexDirection="column"
        justifyContent="center"
      >
        <Particles
          text={[particles.inputValue, particles.dropdownValue?.particleValue1]}
          type={[
            particles.dropdownValue?.particleType ?? "",
            particles.dropdownValue?.particleType1 ?? "",
          ]}
          textColor={textColor}
        />
        <div
          style={{ color: textColor }}
          dangerouslySetInnerHTML={{
            __html: removeInlineColors((data?.description || "").cleanUpString()),
          }}
        />
      </RowContainer>
    </Container>
  );
};

export default GrammarSingleComponent;
